import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { FormGroup, Label } from 'reactstrap'

import './CustomModal/CustomModal.css'

const CustomReactSelectComponent = ({
  label,
  onChange,
  options,
  errorMess,
  invalid,
  placeholder,
  className,
  name,
  isClearable,
  defaultValue,
  isMulti,
  disabled,
  customStyle,
  borderBottomOnly,
}) => {
  let formGroupStyle = {}
  if (errorMess && customStyle) {
    formGroupStyle = {
      ...customStyle,
      marginBottom: '-6px',
    }
  } else if (errorMess) {
    formGroupStyle = {
      marginBottom: '-6px',
    }
  } else if (customStyle) {
    formGroupStyle = {
      ...customStyle,
    }
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '29px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '29px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '5px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '5px',
    }),
    menu: (provided) => ({ ...provided, zIndex: 100000000, color: '#000' }),
    multiValueLabel: (provided) => {
      return {
        ...provided,
        whiteSpace: 'pre-wrap',
      }
    },
    singleValue: (provided) => {
      return {
        ...provided,
        whiteSpace: 'pre-wrap',
        display: 'contents',
      }
    },
  }
  if (borderBottomOnly) {
    customStyles.control = (provided) => ({
      ...provided,
      minHeight: '29px',
      borderBottom: '1px solid lightgray',
      borderTop: '0px',
      borderRight: '0px',
      borderLeft: '0px',
      borderRadius: '0px',
    })
  }
  return (
    <FormGroup style={formGroupStyle} className={`${className} ${invalid ? 'isInvalid' : ''}`}>
      {label ? <Label>{label}</Label> : null}
      <Select
        isMulti={isMulti}
        isClearable={isClearable}
        onChange={onChange}
        options={options}
        isDisabled={disabled}
        invalid={invalid}
        name={name}
        placeholder={placeholder}
        required={true}
        getOptionValue={(option) => option.id || option.value}
        getOptionLabel={(option) => option.name || option.label}
        styles={customStyles}
        value={
          isMulti
            ? (options || []).filter((option) => {
                return (defaultValue || []).includes(option.id) || (defaultValue || []).includes(option.value)
              })
            : // Nullish defaultValue must mean "no selection". Options are usually
            // { value, label } (no `id`), so the old fallback matched on
            // `option.id === defaultValue` → `undefined === undefined` → true and
            // showed the FIRST option on empty/new forms. Guard the nullish case.
            defaultValue === undefined || defaultValue === null || defaultValue === ''
            ? null
            : (options || []).find((option) => option.value === defaultValue || option.id === defaultValue) || null
        }
      />

      <small className='text-danger'>{errorMess}</small>
    </FormGroup>
  )
}

CustomReactSelectComponent.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  errorMess: PropTypes.string,
  className: PropTypes.string,
  isClearable: PropTypes.bool,
  required: PropTypes.bool,
}

CustomReactSelectComponent.defaultProps = {
  required: false,
  disabled: false,
}

export default CustomReactSelectComponent
